import { AppRouter } from "./routes";

export function App() {
  return (
    <AppRouter />
  );
}

export default App;
